export default __webpack_public_path__ + "static/media/gallery_00.5743bae2.jpg";